/**
 * @name GamedayAudioLogin.js
 * @author ychang
 *
 * */
define('gameday-index-gdaAuth/src/GamedayAudioLogin',['require','exports','module','jquery','jquery.etc/jquery.etc','bam.session/session','bam.xd/xd','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','text!gdaAudioTemplate/loginFrame.mustache','bindable/jquery.bindable','jquery.etc/jquery.etc','jquery-ui/jquery-ui.min','gameday-index-configurator/GamedayIndexConfigurator'],function(require, exports, module) {

    var $ = require('jquery');
    var jetc = require('jquery.etc/jquery.etc');
    var session = require('bam.session/session');
    var xd = require('bam.xd/xd');
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var GDAudioLogin;
    var loginViewText = require('text!gdaAudioTemplate/loginFrame.mustache');
    var bindable = require('bindable/jquery.bindable');
    var jetc = require('jquery.etc/jquery.etc');
    var jui = require('jquery-ui/jquery-ui.min');
    var SiteConfig = require("gameday-index-configurator/GamedayIndexConfigurator");
    var purchaseViewPath = "";
    var loginView = Hogan.compile(loginViewText).render();
    var purchaseView;
    var loginViewContainer;
    var secureDomain = "https://betasecure.mlb.com/";
    var loginFormPath;
    var popupConfig = {
        dialogClass: "gda-loginframe",
        autoOpen: false,
        resizable: false,
        minWidth: 580
    };
    var pos = {
        my: "center",
        at: "center",
        of: window
    };

    function GamedayAudioLogin() {
        GamedayAudioLogin.superclass.constructor.call(this);

        this.container = $("#GDLoginIframe");
        this.overlay;
        this._loginFrame;
    }

    $.inherit(GamedayAudioLogin, session, {

        visible: false,

        display: function() {

            this.container.removeClass("upsell").dialog("open").position(pos);
            this.overlay.addClass("show");
            this.visible = true;
        },

        displayUpsell: function() {
            $("#login-form-container iframe").remove();
            this.container.addClass("upsell").dialog("open").position(pos);
            this.overlay.addClass("show");
            this.visible = true;
        },

        hide: function() {
            this.container.removeClass("upsell").dialog("close");
            this.overlay.removeClass("show");
            this.visible = false;
            this.trigger("loginHide");
            this.unbind();
        },


        loadframe: function() {
            
            $("body").append("<div id='gdloginframe-overlay'></div>");
            this.overlay = $("#gdloginframe-overlay");
            var frameDiv = $("#GDLoginIframe");
            var that = this;
            
            if (frameDiv.html() !== "") {
                return false;
            }
            
            loginFormPath = SiteConfig.getSecureDomain() + "/mlb/gameday/responsive/widget-login-iframe/";

            this._loginFrame = xd.iframe({
                    src: loginFormPath
                })
                .bind("loginSuccess", $.proxy(function() {
                    this.isLoggedIn();
                    this._loginFrame.destroy();
                    this.hide();
                }, this))
                .bind("loginError", $.proxy(function() {
                    this.trigger("loginError");
                }, this));

           


            frameDiv.html(loginView).dialog(popupConfig);
            this._loginFrame.create("#login-form-container");

            $("#module_close a").on("click", function() {
                that.hide();
            })

        }

    });


    bindable(GamedayAudioLogin.prototype);

    exports.GamedayAudioLogin = GamedayAudioLogin;


    return exports;

});

